import { getFormattedDate } from '../../../../helpers/localize';
import { TABLE_KEYS } from '../../../../redux_store';
import DownloadTableFile from '../../../Shared/Table/widgets/TopBar/DownloadTableFile';
import MetricsButton from '../../../Shared/Table/widgets/MetricsButton';
import { useSelector } from 'react-redux';

const TableActions = (props) => {
  const { isDistributionSponsor } = useSelector((state) => state.user);
  const tableKey = isDistributionSponsor ? TABLE_KEYS.claimsDSTable : TABLE_KEYS.claimsTable;

  return <>
    <MetricsButton title={'claims'} aggregations={props.aggregations} filter={props.filter}/>
    <DownloadTableFile
      fileName={`Claims ${getFormattedDate(new Date(Date.now()))}.csv`}
      endpoint={'/export-claims.csv'}
      tableKey={tableKey}
      {...props}
    /></>;
};

export default TableActions;
